export default __webpack_public_path__ + "static/media/mp4.e8050f9e.png";